<div class="column-configurator" (click)="$event.stopPropagation()">
    <button
        class="btn btn-sm btn-info"
        #columnConfigAnchor
        kendoTooltip
        title="{{ title | translate }}"
        (click)="toggle($event)">
        <fa-icon [icon]="['fas', 'columns']"></fa-icon>
    </button>
    @if (!isDefaultLayout) {
        <span class="badge badge-pill badge-danger column-config-badge">
            {{ checkedColumnsCount }}
        </span>
    }

    @if (isOpen) {
        <kendo-popup [anchor]="columnConfigAnchor" [anchorAlign]="anchorAlign" [popupAlign]="popupAlign">
            <div class="column-config-panel bg-card text-muted" (click)="$event.stopPropagation()">
                <div class="column-config-title">{{ title | translate }}</div>
                <div class="column-config-bulk-actions">
                    <button
                        class="btn btn-sm btn-link p-0"
                        kendoTooltip
                        title="{{ 'Check all' | translate }}"
                        (click)="setAllVisibility(true, $event)">
                        <fa-icon [icon]="['far', 'check-square']"></fa-icon>
                    </button>
                    <button
                        class="btn btn-sm btn-link p-0 ml-2"
                        kendoTooltip
                        title="{{ 'Uncheck all' | translate }}"
                        (click)="setAllVisibility(false, $event)">
                        <fa-icon [icon]="['far', 'square']"></fa-icon>
                    </button>
                    <button
                        class="btn btn-sm btn-link p-0 ml-2"
                        kendoTooltip
                        title="{{ resetTitle | translate }}"
                        (click)="resetLayout($event)">
                        <fa-icon [icon]="['fas', 'undo']"></fa-icon>
                    </button>
                </div>
                <div
                    class="column-config-list"
                    cdkDropList
                    [cdkDropListSortPredicate]="canSortInto"
                    (cdkDropListDropped)="onColumnDrop($event)">
                    @for (column of visibleColumns; track column) {
                        <label
                            class="column-config-item"
                            cdkDrag
                            cdkDragLockAxis="y"
                            [class.column-config-item-locked]="column.locked"
                            [cdkDragDisabled]="column.locked"
                            (cdkDragEnded)="onDragEnded()">
                            @if (column.locked) {
                                <span
                                    class="column-config-slot column-config-locked-slot"
                                    kendoTooltip
                                    title="{{
                                        'This column is locked: it always stays visible and in place' | translate
                                    }}">
                                    <fa-icon [icon]="['fas', 'lock']"></fa-icon>
                                </span>
                            } @else {
                                <span class="column-config-slot column-config-handle-slot">
                                    <fa-icon
                                        class="column-config-drag-handle"
                                        cdkDragHandle
                                        [icon]="['fas', 'grip-vertical']"></fa-icon>
                                </span>
                                <span
                                    class="column-config-slot column-config-check-slot"
                                    [attr.title]="
                                        isLastVisibleMovable(column)
                                            ? ('At least one column next to the locked one must stay visible'
                                              | translate)
                                            : null
                                    ">
                                    <input
                                        type="checkbox"
                                        [checked]="isColumnVisible(column.key)"
                                        [disabled]="isLastVisibleMovable(column)"
                                        (click)="$event.stopPropagation()"
                                        (change)="onVisibilityChange(column.key, $event)" />
                                </span>
                            }
                            <span>{{ column.title | translate }}</span>
                        </label>
                    }
                </div>
            </div>
        </kendo-popup>
    }
</div>
